'use client'

import {
  AssignmentRulesListMachineProvider,
  BillingListMachineProvider,
  ChannelListMachineProvider,
  CurrentInteractionMachineProvider,
  CustomerListMachineProvider,
  EscalationListMachineProvider,
  InteractionListMachineProvider,
  KnowledgeListMachineProvider,
  LeadListMachineProvider,
  MemberListMachineProvider,
  NewMessagesListMachineProvider,
  NotificationTemplateListMachineProvider,
  QueueListMachineProvider,
  RoutingListMachineProvider,
  SlaListMachineProvider,
  TagListMachineProvider,
  TaskListMachineProvider,
  TicketCategoryListMachineProvider,
  SlaMonitorListMachineProvider,
} from '@repo/crm'
import { CrmSyncMachinesProvider } from '@/shared/lib/crm-sync-machines'

/**
 * App-level CRM state providers.
 *
 * `useCrmSync()` is consumed outside the `/admin/crm` route subtree
 * (for example in admin billing), so these stores must be available
 * at the application level rather than only in the CRM layout.
 */
export function CrmMachineProviders({ children }: { children: React.ReactNode }) {
  return (
    <CrmSyncMachinesProvider>
      <CustomerListMachineProvider>
        <TagListMachineProvider>
          <MemberListMachineProvider>
            <ChannelListMachineProvider>
              <QueueListMachineProvider>
                <TicketCategoryListMachineProvider>
                  <SlaListMachineProvider>
                    <NotificationTemplateListMachineProvider>
                      <LeadListMachineProvider>
                        <NewMessagesListMachineProvider>
                          <CurrentInteractionMachineProvider>
                            <InteractionListMachineProvider>
                              <KnowledgeListMachineProvider>
                                <BillingListMachineProvider>
                                  <RoutingListMachineProvider>
                                    <EscalationListMachineProvider>
                                      <AssignmentRulesListMachineProvider>
                                        <SlaMonitorListMachineProvider>
                                          <TaskListMachineProvider>{children}</TaskListMachineProvider>
                                        </SlaMonitorListMachineProvider>
                                      </AssignmentRulesListMachineProvider>
                                    </EscalationListMachineProvider>
                                  </RoutingListMachineProvider>
                                </BillingListMachineProvider>
                              </KnowledgeListMachineProvider>
                            </InteractionListMachineProvider>
                          </CurrentInteractionMachineProvider>
                        </NewMessagesListMachineProvider>
                      </LeadListMachineProvider>
                    </NotificationTemplateListMachineProvider>
                  </SlaListMachineProvider>
                </TicketCategoryListMachineProvider>
              </QueueListMachineProvider>
            </ChannelListMachineProvider>
          </MemberListMachineProvider>
        </TagListMachineProvider>
      </CustomerListMachineProvider>
    </CrmSyncMachinesProvider>
  )
}
